import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Swal from 'sweetalert2';

export default function ParaLlevar() {
  const [ordenes, setOrdenes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creando, setCreando] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [nombreCliente, setNombreCliente] = useState('');
  const [direccionCliente, setDireccionCliente] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    cargarOrdenes();
  }, []);

  const cargarOrdenes = async () => {
    try {
      const res = await api.get('/ordenes/para-llevar/activas');
      setOrdenes(res.data);
    } catch {
      setOrdenes([]);
    } finally {
      setLoading(false);
    }
  };

  const abrirModal = () => {
    setNombreCliente('');
    setDireccionCliente('');
    setShowModal(true);
  };

  const crearOrden = async () => {
    if (creando) return;
    setCreando(true);
    try {
      const res = await api.post('/ordenes/para-llevar', {
        nombre_cliente: nombreCliente || null,
        direccion_cliente: direccionCliente || null,
      });
      setShowModal(false);
      navigate(`/ordenes/${res.data.id}`);
    } catch {
      Swal.fire('Error', 'No se pudo crear el pedido', 'error');
    } finally {
      setCreando(false);
    }
  };

  const cancelarOrden = async (ordenId, e) => {
    e.stopPropagation();
    const result = await Swal.fire({
      title: '¿Cancelar pedido?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, cancelar',
      cancelButtonText: 'No',
      confirmButtonColor: '#d33',
    });
    if (result.isConfirmed) {
      try {
        await api.delete(`/ordenes/para-llevar/${ordenId}`);
        cargarOrdenes();
        Swal.fire('Cancelado', 'Pedido cancelado correctamente', 'success');
      } catch {
        Swal.fire('Error', 'No se pudo cancelar el pedido', 'error');
      }
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  return (
    <div className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-0">Para Llevar / Delivery</h2>
          <small className="text-muted">{ordenes.length} pedido{ordenes.length !== 1 ? 's' : ''} activo{ordenes.length !== 1 ? 's' : ''}</small>
        </div>
        <button className="btn btn-primary" onClick={abrirModal}>
          + Nuevo Pedido
        </button>
      </div>

      {ordenes.length === 0 ? (
        <div className="text-center mt-5">
          <div style={{ fontSize: 64 }}>📦</div>
          <h5 className="text-muted mt-3">No hay pedidos activos</h5>
          <p className="text-muted">Crea un nuevo pedido para comenzar</p>
          <button className="btn btn-primary mt-2" onClick={abrirModal}>
            + Nuevo Pedido
          </button>
        </div>
      ) : (
        <div className="row g-3">
          {ordenes.map((orden) => (
            <div key={orden.id} className="col-12 col-md-6 col-lg-4">
              <div
                className="card h-100"
                style={{
                  borderTop: '4px solid #3b82f6',
                  borderRadius: '12px',
                  cursor: 'pointer',
                }}
                onClick={() => navigate(`/ordenes/${orden.id}`)}
              >
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="mb-0">Pedido #{orden.id}</h5>
                    <span className="badge bg-primary">📦 Para Llevar</span>
                  </div>
                  {orden.nombre_cliente && (
                    <p className="mb-1" style={{ fontSize: 13, fontWeight: 600 }}>
                      👤 {orden.nombre_cliente}
                    </p>
                  )}
                  {orden.direccion_cliente && (
                    <p className="text-muted mb-1" style={{ fontSize: 13 }}>
                      📍 {orden.direccion_cliente}
                    </p>
                  )}
                  <p className="text-muted mb-1" style={{ fontSize: 13 }}>
                    {orden.items?.length || 0} producto{(orden.items?.length || 0) !== 1 ? 's' : ''}
                  </p>
                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                      Total: <strong>${parseFloat(orden.total || 0).toFixed(2)}</strong>
                    </p>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={(e) => cancelarOrden(orden.id, e)}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal Nuevo Pedido */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">📦 Nuevo Pedido Para Llevar</h5>
                <button className="btn-close" onClick={() => setShowModal(false)} />
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Nombre del cliente (opcional)</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: Juan Pérez"
                    value={nombreCliente}
                    onChange={(e) => setNombreCliente(e.target.value)}
                    autoFocus
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Dirección (opcional)</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: Calle Principal #123"
                    value={direccionCliente}
                    onChange={(e) => setDireccionCliente(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Cancelar
                </button>
                <button className="btn btn-primary" onClick={crearOrden} disabled={creando}>
                  {creando ? (
                    <><span className="spinner-border spinner-border-sm me-2" />Creando...</>
                  ) : 'Crear Pedido'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}